import { render, staticRenderFns } from "./PartnerIndex.vue?vue&type=template&id=b662805c&scoped=true"
import script from "./PartnerIndex.vue?vue&type=script&lang=js"
export * from "./PartnerIndex.vue?vue&type=script&lang=js"
import style0 from "./PartnerIndex.vue?vue&type=style&index=0&id=b662805c&prod&lang=less&scoped=true"
import style1 from "./PartnerIndex.vue?vue&type=style&index=1&id=b662805c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662805c",
  null
  
)

export default component.exports